export default __webpack_public_path__ + "static/media/RentCafe Multi-Property Credentials (1).3900d223.csv";